import React from "react";
import classNames from "classnames";
import withStyles from "@material-ui/core/styles/withStyles";
// React icons
import { FaLinkedin } from 'react-icons/fa';
// core components

import Collapse from '@material-ui/core/Collapse';

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

import teamStyle from "assets/jss/material-kit-react/views/landingPageSections/teamStyle.jsx";

import team from "data/team.json";
import SungChoi from "components/Image/SungChoi.jsx";
import CharlieGunyon from "components/Image/CharlieGunyon.jsx";
import StephenKao from "components/Image/StephenKao.jsx";

class CollapsableCard extends React.Component {
    state = {
    isOpened: this.props.isOpen,
  };

  onReadMoreClick = id => {
    this.setState((state) => {
      return { 
        isOpened: !this.state.isOpened
      }
    });
  };

  render() {
    const { isOpened } = this.state;
    const {
      classes,
      card
    } = this.props;

    return (
      <div>
        <CardBody className={classes.cardBody}>
          <p className={classes.description} dangerouslySetInnerHTML={{__html: `${card.text[0]}`}}></p>
          <Collapse in={isOpened}>
            { card.text.map((line, index) => (
              index > 0 ? 
              <p className={classes.description} dangerouslySetInnerHTML={{__html: `${line}`}}></p>
              : ""))
            }
          </Collapse>                
        </CardBody>
        <CardBody className={classes.cardBody}>
          <a className={classes.openCloseButton} onClick={this.onReadMoreClick} aria-label={this.state.isOpened ? "Read less." : "Read more."}>
            {this.state.isOpened ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
          </a>
        </CardBody>
      </div>
    )
  }
}


class TeamSection extends React.Component {
  render() {
    const { classes } = this.props;
    const imageClasses = classNames(
      classes.imgRaised,
      classes.imgRoundedCircle,
      classes.imgFluid
    );

    const teamPictures = {
      "Sung Choi": <SungChoi classes={classes}/>,
      "Charlie Gunyon": <CharlieGunyon classes={classes}/>,
      "Stephen Kao": <StephenKao classes={classes}/>
    };

    return (
      <div id="team" className={classes.section}>
        <GridContainer justify="center">
        <GridItem xs={12}>
        <h2 className={classes.title}>
        Our Team
        <br/>
        <small className={classes.smallTitle}>If you want to go far, go together.</small>
        </h2>
        </GridItem>
        </GridContainer>
        <div>
          <GridContainer>
          {team.map(card => (
            <GridItem xs={12} sm={6} md={4}>
              <Card raised className={classes.card}>
                <GridItem xs={6} className={classes.itemGrid}>
                  {teamPictures[card.title]}
                </GridItem>
                <h4 className={classes.cardTitle}>
                  {card.title}
                  <br />
                  <small className={classes.smallTitle}>{card.subtitle}</small>
                </h4>
                <CollapsableCard classes={classes} isOpen={false} card={card}/>
              </Card>
            </GridItem>))}
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(teamStyle)(TeamSection);
